export default __webpack_public_path__ + "static/media/biper-crop.f3ed43a0.jpg";